import { useState } from "react";
import { CLINIC } from "../clinic";
import { sendClinicMail } from "../api/mail";
import "./Contact.css";

const initialForm = {
  name: "",
  email: "",
  phone: "",
  message: "",
};

export default function Contact() {
  const [formData, setFormData] = useState(initialForm);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: "", text: "" });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: "", text: "" });

    try {
      await sendClinicMail({
        ...formData,
        type: "contact",
        subject: "SmileHub contact form",
        message: `[Contact form]\n${formData.message}`,
        date: new Date().toISOString().split("T")[0],
        time: "09:00",
      });
      setStatus({
        type: "success",
        text: "Message sent. We will reply as soon as we can.",
      });
      setFormData(initialForm);
    } catch {
      setStatus({
        type: "error",
        text: "Could not send your message. Please email or call the clinic.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="contact section" id="contact">
      <div className="container">
        <h2 className="section-title">How to Find Us</h2>
        <a
          href={CLINIC.mapsUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="btn"
        >
          View on Google Map
        </a>
        <div className="contact-info">
          <p>
            <strong>Phone:</strong>{" "}
            <a href={`tel:${CLINIC.phone}`}>0777421620</a>
          </p>
          <p>
            <strong>Email:</strong>{" "}
            <a href={`mailto:${CLINIC.email}`}>{CLINIC.email}</a>
          </p>
        </div>

        <form className="clinic-form contact-form" onSubmit={handleSubmit}>
          <h3>Send a message</h3>
          <input
            name="name"
            placeholder="Full Name"
            autoComplete="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            name="email"
            type="email"
            placeholder="Email"
            autoComplete="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            name="phone"
            type="tel"
            placeholder="Phone Number"
            autoComplete="tel"
            inputMode="tel"
            value={formData.phone}
            onChange={handleChange}
            required
          />
          <textarea
            name="message"
            placeholder="Your message"
            value={formData.message}
            onChange={handleChange}
            required
          />
          <button className="btn" type="submit" disabled={loading}>
            {loading ? "Sending..." : "Send Message"}
          </button>
          {status.text && (
            <p className={`form-status ${status.type}`}>{status.text}</p>
          )}
        </form>
      </div>
    </section>
  );
}
